// extracted by mini-css-extract-plugin
module.exports = {"list":"Setting_list_10duC","content":"Setting_content_2E1ht","btn":"Setting_btn_2yjur","isDevelop":"Setting_isDevelop_Oik27"};